module.exports = __webpack_public_path__ + "img/product-shot_03.53cbeca5.jpg";